export enum PersonSearchState {
    Concept1 = 0,
    Concept2ByCertificateId = 1,
    Concept2ByPersonNumber = 2,
    Concept2ByPersonNumberFound = 3,
    Concept2ByPersonNumberNotFound = 4,
    Concept2NoSwedishPersonNumber = 5,
    FinlandByShortNumber = 6,
    FinlandByShortNumberNotFound = 7,
    NorwayByShortNumber = 8,
    NorwayByShortNumberNotFound = 9,
    DenmarkByEmail = 10,
    DenmarkByEmailNotFound = 11,
    OtherCountry = 12,
}
